import React, { useEffect, useState, useMemo, useCallback, useRef } from "react";
import { FormattedMessage } from "react-intl";
import _ from "lodash";
import ReactSelect, { components } from "react-select";
import { useFormikContext } from "formik";
import { FieldError, useFieldCSSClasses } from "./FieldError";
import useHideAndShowField from "./hooks/useHideAndShowField";
import { getAttr } from "src/helpers";

const Option = (props) => {
  return (
    <components.Option {...props}>
      <div className="d-flex justify-content-between align-items-center">
        <div>{props.data.label}</div>
        <div style={{ fontSize: 12 }}>{props.data.subLabel}</div>
      </div>
    </components.Option>
  );
};

const Select = ({
  label,
  size = 12,
  placeholder,
  isLoading,
  withSubmit,
  onInputChange,
  options = [],
  multiple = false,
  chainedOptions,
  refreshOptions = true,
  loadOptions,
  loadDebounceOptions,
  loadDebounceOptions1,
  loadDebounceOptions2,
  loadValueAttr,
  initialValue = "",
  saveOptions,
  required = false,
  disabled = false,
  relyOn = null,
  chainedField = null,
  chainedFieldValue,
  field,
  saveLabel = false,
  form,
  inputGroupClassName = "form-group",
  fixInitialValue = undefined,
  formRepeater = false,
  getFirstValue = false,
  emit,
  initialValueChainedField = "",
  resetConditionValue = undefined,
  IsRepeater = false,
  metadataChainedField = {},
  preFilledConditionsOptions = [],
  autormpliField = [],
  radioChainedField,
  forceInit = false,
  customMessage,
  fixedValues = [],
  isClearable = true,
  ...props
}) => {
  const fieldCSSClasses = useFieldCSSClasses(
    form.touched,
    form.errors,
    field.name
  );
  const formik = useFormikContext();
  const conditionalShowAndHideClassName = useHideAndShowField({
    formik,
    fieldName: field.name,
    ...props,
  });
  const previousValueRef = useRef();
  const isMountedRef = useRef(true);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  // Track mount status for async/debounced callbacks
  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  // Safe setter that checks mount status before updating state
  const safeSetSelectedOptions = useCallback((options) => {
    if (isMountedRef.current) {
      setSelectedOptions(options);
    }
  }, []);

  const onSelectChange = (option, { action }) => {
    let choices = "";
    let labels = "";
    if (action === "clear" && !_.isEmpty(chainedField) && IsRepeater === true) {
      const [formRepeaterName, index] = field.name.split('.');
      const fieldName = formRepeaterName + "[" + index + "]." + chainedField
      form.setFieldValue(fieldName, []);
      formik.setFieldValue(fieldName, []);

      if (!_.isEmpty(metadataChainedField)) {
        const fieldName2 = formRepeaterName + "[" + index + "]." + metadataChainedField.chainedField
        form.setFieldValue(fieldName2, []);
        formik.setFieldValue(fieldName2, []);
      }
      if (_.isFunction(emit)) {
        emit({ type: `CLEAR_${field.name.toUpperCase()}` }) // for clearing
      }

    }

    if (action === "clear" && !_.isEmpty(chainedField)) {
      form.setFieldValue(chainedField, []);
      formik.setFieldValue(chainedField, []);

      if (_.isFunction(emit)) {
        emit({ type: `CLEAR_${field.name.toUpperCase()}` }) // for clearing
      }

    }


    if (action === "clear" && !_.isEmpty(metadataChainedField)) {
      // form.setFieldValue(chainedField, []);
      // formik.setFieldValue(chainedField, []);

      form.setFieldValue(metadataChainedField.chainedField, []);
      formik.setFieldValue(metadataChainedField.chainedField, []);
      if (_.isFunction(emit)) {
        emit({ type: `CLEAR_${field.name.toUpperCase()}` }) // for clearing
      }

    }
    if (action === "clear" && autormpliField.length !== 0) {
      if (IsRepeater) {
        const [formRepeaterName, index] = field.name.split('.');
        autormpliField.map(e => {
          const fieldName = formRepeaterName + "[" + index + "]." + e.name;
          form.setFieldValue(fieldName, e.default);
          formik.setFieldValue(fieldName, e.default);
        })
      } else {
        autormpliField.map(e => {
          form.setFieldValue(e.name, e.default);
          formik.setFieldValue(e.name, e.default);
        })
      }
    }

    if (!_.isArray(option) && _.has(option, "value")) {
      choices = option.value;
      if (!_.isEmpty(chainedField)) {
        form.setFieldValue(chainedField, []);
        formik.setFieldValue(chainedField, []);
      }
      if (saveLabel && _.has(option, "label")) {
        labels = option.label;
      }
      if (autormpliField.length !== 0) {
        if (IsRepeater) {
          const [formRepeaterName, index] = field.name.split('.');
          autormpliField.map(e => {
            let source = option[e.source];
            const fieldName = formRepeaterName + "[" + index + "]." + e.name;
            form.setFieldValue(fieldName, source ? source[0] : e.default);
            formik.setFieldValue(fieldName, source ? source[0] : e.default);
          })
        } else {
          autormpliField.map(e => {
            let source = option[e.source];
            form.setFieldValue(e.name, source ? source[0] : e.default);
            formik.setFieldValue(e.name, source ? source[0] : e.default);
          })
        }
      }
      /* } else if (_.isArray(option)) {
        choices = option.map((choice) => choice.value);
        labels = option.map((label) => label.label);
      } */
    } else if (_.isArray(option)) {
      const userChoices = option.map((choice) => choice.value);

      const mergedChoices = _.uniq([...userChoices, ...fixedValues]);
      choices = mergedChoices;

      labels = option
        .filter((opt) => mergedChoices.includes(opt.value))
        .map((opt) => opt.label);
    }
    // if(autormpliField.length!=0&&!_.isArray(option)) {
    //   autormpliField.map(e=>{
    //     let source = option[e.source]
    //     form.setFieldValue(e.name,source&&source.length!==0?source[0]:e.default );
    //     formik.setFieldValue(field.name, source&&source.length!==0?source[0]:e.default  )

    //   })
    // }
    if (_.isFunction(props.onChange)) {
      try {
        props.onChange(option, formik);
      } catch (err) {
        console.error("Error in custom onChange handler:", err);
      }
    }
    form.setFieldTouched(field.name, true);
    form.setFieldValue(field.name, choices);
    if (saveLabel) {
      form.setFieldValue(`${field.name}ConfirmationLabel`, labels);
    }
    if (_.isFunction(emit)) {
      emit({ type: `CHANGE_${field.name.toUpperCase()}`, payload: choices })
    }
  };

  const refresh = (touched = false) => {
    if (touched) formik.setFieldTouched(field.name, true);
    formik.setFieldValue(field.name, field.value ? field.value : []);
  };

  useEffect(() => {
    let RadioChainedField = getAttr(formik.values, radioChainedField)
    //console.log({RadioChainedField})
    if (RadioChainedField && forceInit && initialValue) {
      form.setFieldValue(field.name, initialValue);
      formik.setFieldValue(field.name, initialValue);
    }
  }, [getAttr(formik.values, radioChainedField)]); // Log the value whenever resetError changes


  useEffect(() => {
    _.isFunction(withSubmit) &&
      !_.isNull(form.values) &&
      withSubmit(form?.values);
    return () => { };
  }, [form.values, withSubmit]);
  useEffect(() => {
    let choices = [];
    if (!_.isArray(field.value) && field.value && _.isArray(selectedOptions)) {
      choices.push(
        selectedOptions.find((option) => option.value === field.value)
      );
    }
    if (_.isArray(field.value) && _.isArray(selectedOptions)) {
      choices = selectedOptions.filter((option) =>
        field.value.includes(option.value)
      );
    }

    const fieldTouched =
      _.get(form.touched, field.name, false) || _.isEmpty(selectedOptions);

    if (!_.isEmpty(saveOptions) && _.isPlainObject(saveOptions)) {
      form.setFieldValue(
        saveOptions.ref,
        _.flatten(_.map(choices, saveOptions.attr))
      );
    }
    if (!_.isEmpty(saveOptions) && fieldTouched && _.isArray(saveOptions)) {
      saveOptions.forEach((field) => {
        let value = _.map(choices, field.attr);
        //if (!_.every(value, _.isEmpty)){
        value = _.flatten(value);
        form.setFieldValue(
          field.ref,
          _.isFunction(field.formatter) ? field.formatter(value) : value
        );
        //}
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [field.value && selectedOptions]);

  useEffect(() => {
    if (_.isPlainObject(field.value) && _.has(field.value, "id")) {
      form.setFieldValue(field.name, _.get(field.value, "id", ""));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_.isPlainObject(field.value)]);

  useEffect(() => {
    const loadValues = _.get(formik.values, loadValueAttr);
    if (
      _.isArray(loadValues) &&
      loadValues.every((item) => _.has(item, "id"))
    ) {
      form.setFieldValue(
        field.name,
        loadValues.map((item) => _.get(item, "id", ""))
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_.get(formik.values, loadValueAttr)]);

  const memoizedLoadOptions = useMemo(() => {
    return async () => {
      await loadOptions(setSelectedOptions);
      return setSelectedOptions;
    };
  }, []);

  useEffect(() => {
    if (_.isFunction(loadOptions) && _.isEmpty(selectedOptions)) {
      memoizedLoadOptions();
    }
    if (options && _.isEmpty(selectedOptions)) {
      setSelectedOptions(options);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (options && _.isEmpty(selectedOptions)) {
      setSelectedOptions(options);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValue]);



  useEffect(() => {
    if (_.isFunction(loadOptions) && !_.isNull(relyOn) && fixInitialValue) {
      formik.setFieldValue(field.name, fixInitialValue)
      loadOptions(setSelectedOptions);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getAttr(formik.values, relyOn)]);





  useEffect(() => {

    if (saveLabel) {
      form.setFieldValue(`${field.name}ConfirmationLabel`, selectedOptions.find(item => item.value === getAttr(formik.values, field.name))?.label);
    }
    return () => {

    }
  }, [selectedOptions])




  useEffect(() => {

    if (!_.isEmpty(initialValueChainedField) && resetConditionValue) {

      if (getAttr(formik.values, initialValueChainedField, undefined) === resetConditionValue) {
        form.setFieldValue(field.name, "");
        formik.setFieldValue(field.name, "")


      }
      else {
        form.setFieldValue(field.name, initialValue);
        formik.setFieldValue(field.name, initialValue);
      }
    }

    return () => {

    }
  }, [getAttr(formik.values, initialValueChainedField)])




  useEffect(() => {

    if (getFirstValue && !_.isEmpty(selectedOptions)) {
      form.setFieldValue(`${field.name}`, multiple ? [selectedOptions[0].value] : selectedOptions[0].value);
      formik.setFieldValue(`${field.name}`, multiple ? [selectedOptions[0].value] : selectedOptions[0].value)
    }
    return () => {

    }
  }, [selectedOptions])

  useEffect(() => {
    if (_.isFunction(chainedOptions) && !_.isNull(relyOn) && !formRepeater) {
      chainedOptions(setSelectedOptions, formik.values);
    }
    if (
      !_.isUndefined(chainedOptions) &&
      _.isEmpty(getAttr(formik.values, relyOn)) &&
      refreshOptions === true
    ) {
      // setSelectedOptions([])
      refresh();
    }
    // eslint-disable-next-line
  }, [getAttr(formik.values, relyOn)]);


  // Get the specific relyOn value for this row to use as a targeted dependency
  const rowRelyOnValue = useMemo(() => {
    if (formRepeater && relyOn && field.name) {
      const [formRepeaterName, index] = field.name.split('.');
      const fieldName = `${formRepeaterName}[${index}].${relyOn}`;
      return getAttr(formik.values, fieldName);
    }
    return undefined;
  }, [formRepeater, relyOn, field.name, formik.values]);

  useEffect(() => {
    if (_.isFunction(chainedOptions) && !_.isNull(relyOn) && formRepeater) {
      const [formRepeaterName, index] = field.name.split('.');
      const fieldName = formRepeaterName + "[" + index + "]." + relyOn
      chainedOptions(safeSetSelectedOptions, getAttr(formik.values, fieldName)); // getAttr dose   all the magic
    }
    if (
      !_.isUndefined(chainedOptions) &&
      _.isEmpty(getAttr(formik.values, relyOn)) &&
      refreshOptions === true
    ) {
      // setSelectedOptions([])
      refresh();
    }
    // eslint-disable-next-line
  }, [rowRelyOnValue, formRepeater]);

  const debouncedChainedOptions = useCallback(
    _.debounce((setter, values) => {
      if (_.isFunction(chainedOptions) && isMountedRef.current) {
        if (_.isArray(values)) {
          chainedOptions(setter, ...values);
        }
        else {
          chainedOptions(setter, values);
        }
      }
    }, 500), // Adjust the debounce delay as needed
    [chainedOptions]
  );

  // Cancel debounced calls on unmount
  useEffect(() => {
    return () => {
      debouncedChainedOptions.cancel();
    };
  }, [debouncedChainedOptions]);

  useEffect(() => {
    if (_.isFunction(chainedOptions) && !_.isNull(relyOn) && !formRepeater) {
      debouncedChainedOptions(safeSetSelectedOptions, formik.values);
    }
    if (
      !_.isUndefined(chainedOptions) &&
      _.isEmpty(getAttr(formik.values, relyOn)) &&
      refreshOptions === true
    ) {
      // setSelectedOptions([])
      refresh();
    }
    // eslint-disable-next-line
  }, [
    ...(Array.isArray(relyOn)
      ? relyOn.map((fieldName) => getAttr(formik.values, fieldName))
      : [getAttr(formik.values, relyOn)]),
  ]);

  useEffect(() => {
    if (_.isFunction(chainedOptions) && !_.isNull(relyOn) && formRepeater) {
      const [formRepeaterName, index] = field.name.split(".");
      if (Array.isArray(relyOn)) {
        const relyOnValues = relyOn.map((field) => {
          const fieldName = `${formRepeaterName}[${index}].${field}`;
          return getAttr(formik.values, fieldName);
        });
        debouncedChainedOptions(safeSetSelectedOptions, relyOnValues);
      } else {
        const fieldName = `${formRepeaterName}[${index}].${relyOn}`;
        const relyOnValue = getAttr(formik.values, fieldName);
        debouncedChainedOptions(safeSetSelectedOptions, relyOnValue);
      }
      if (
        !_.isUndefined(chainedOptions) &&
        _.isEmpty(getAttr(formik.values, relyOn)) &&
        refreshOptions === true
      ) {
        refresh();
      }
      // eslint-disable-next-line
    }
  }, [
    formRepeater,
    refreshOptions,
    field.name,
    ...(Array.isArray(relyOn)
      ? relyOn.map((f) => {
        const [formRepeaterName, index] = field.name.split(".");
        const fieldName = `${formRepeaterName}[${index}].${f}`;
        return getAttr(formik.values, fieldName);
      }) // Add specific fields to the dependency array
      : (() => {
        const [formRepeaterName, index] = field.name.split(".");
        const fieldName = `${formRepeaterName}[${index}].${relyOn}`;
        return [getAttr(formik.values, fieldName)];
      })()),
  ]);

  let selectedValues = useMemo(() => {
    if (!_.isEmpty(relyOn) && !_.isArray(relyOn) && formRepeater === true && previousValueRef.current !== undefined && previousValueRef.current.length !== 0) {
      const [formRepeaterName, index] = field.name.split('.');
      const fieldName = formRepeaterName + "[" + index + "]." + relyOn
      console.log("wwwwwwwwwwwwwwwwwwww", formRepeaterName, fieldName, getAttr(formik.values, fieldName))
      const relyOnValue = getAttr(formik.values, fieldName);
      if (!relyOnValue || relyOnValue.length === 0) {
        previousValueRef.current = [];
        return []
      }
    }
    if (!_.isArray(field.value) && _.isArray(selectedOptions)) {
      previousValueRef.current = selectedOptions.find((option) => option.value === field.value);
      return selectedOptions.find((option) => option.value === field.value);
    }
    if (_.isArray(field.value) && _.isArray(selectedOptions)) {
      previousValueRef.current = selectedOptions.filter((option) =>
        field.value.includes(option.value)
      );
      return selectedOptions.filter((option) =>
        field.value.includes(option.value)
      );
    }
    previousValueRef.current = field.value || (multiple ? [] : "")
    return field.value || (multiple ? [] : "");
    // eslint-disable-next-line
  }, [field.value, selectedOptions]);
  useEffect(() => {

    if (preFilledConditionsOptions.length !== 0 && !_.isNull(relyOn)) {
      if (formRepeater === true) {
        const [formRepeaterName, index] = field.name.split('.');
        const fieldName = formRepeaterName + "[" + index + "]." + relyOn
        const prermplit = preFilledConditionsOptions.find(el => el.relyOnValue === getAttr(formik.values, fieldName))

        if (prermplit && selectedOptions.find(e => e.value === prermplit.preFilledValue)) {
          selectedValues = selectedOptions.filter(e => e.value === prermplit.preFilledValue)
          form.setFieldValue(field.name, prermplit.preFilledValue);
          formik.setFieldValue(field.name, prermplit.preFilledValue)
        }
      }
      else {
        const prermplit = preFilledConditionsOptions.find(el => el.relyOnValue === getAttr(formik.values, relyOn))
        if (prermplit && selectedOptions.find(e => e.value === prermplit.preFilledValue)) {
          selectedValues = selectedOptions.filter(e => e.value === prermplit.preFilledValue)
          form.setFieldValue(field.name, prermplit.preFilledValue);
          formik.setFieldValue(fieldName, prermplit.preFilledValue)
        }
      }
    }
    // eslint-disable-next-line
  }, [getAttr(formik.values, relyOn), selectedOptions]);


  const customStyles = {
    control: (base, state) => ({
      ...base,
      background: disabled ? "#D6D6D6" : "#FAFAFA",
      border: "1px solid #D6D6D6",
      minHeight: 40,
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: "#757575", // Custom colour
    }),
    loadingIndicator: (base) => ({
      ...base,
      color: "#E02D39",
    }),
  };

  const [formRepeaterName, index] = field.name.split('.');
  const fieldName = formRepeaterName + "[" + index + "]." + relyOn
  const debouncedLoadOptions = useCallback(
    _.debounce((callback, inputValue) => {
      callback(setSelectedOptions, getAttr(formik.values, fieldName), inputValue, setLoading)
    }, 500),
    [getAttr(formik.values, fieldName)]
  );


  const fieldName1 = relyOn;
  const debouncedLoadOptions1 = useCallback(
    _.debounce((callback, inputValue) => {
      callback(setSelectedOptions, getAttr(formik.values, fieldName1), inputValue, setLoading);
    }, 500),
    [getAttr(formik.values, fieldName1)]
  );


  const debouncedLoadOptions2 = useCallback(
    _.debounce((callback, inputValue) => {
      callback(setSelectedOptions, inputValue, setLoading);
    }, 500),
    []
  );



  const handleInputChange = (inputValue, actionMeta) => {
    if (actionMeta.action === 'input-change') {
      debouncedLoadOptions(loadDebounceOptions, inputValue);
    }
  };
  const handleInputChange1 = (inputValue, actionMeta) => {
    if (actionMeta.action === 'input-change') {
      debouncedLoadOptions1(loadDebounceOptions1, inputValue);
    }
  };
  const handleInputChange2 = (inputValue, actionMeta) => {
    if (actionMeta.action === 'input-change') {
      debouncedLoadOptions2(loadDebounceOptions2, inputValue);
    }
  };
  return (
    <div
      className={
        inputGroupClassName +
        conditionalShowAndHideClassName +
        ` col-lg-${size}`
      }
    >
      {label && (
        <label className="custom-label-style">
          {" "}
          {label} <span>{required && "*"}</span>
        </label>
      )}
      {
        customMessage
      }
      <ReactSelect
        menuShouldScrollIntoView={false}
        isDisabled={disabled}
        styles={customStyles}
        //components={{ IndicatorSeparator: () => null, Option }}
        components={{
          IndicatorSeparator: () => null,
          Option,
          MultiValueRemove: (props) =>
            fixedValues.includes(props.data.value)
              ? null
              : <components.MultiValueRemove {...props} />,
        }}
        className={fieldCSSClasses}
        placeholder={placeholder || <FormattedMessage id="GENERAL.SELECT" />}
        options={selectedOptions}
        name={field.name}
        value={selectedValues || []}
        onChange={onSelectChange}
        onBlur={field.onBlur}
        onInputChange={loadDebounceOptions && handleInputChange || loadDebounceOptions1 && handleInputChange1 || loadDebounceOptions2 && handleInputChange2}
        isMulti={multiple}
        noOptionsMessage={() => (
          <FormattedMessage id="GENERAL.SELECT.NO_OPTIONS" />
        )}
        isSearchable
        isClearable={isClearable}
        loadingMessage={() => <FormattedMessage id="GENERAL.LOADING" />}
        isLoading={
          (isLoading && _.isEmpty(options) && _.isEmpty(selectedOptions)) || loading
            ? true
            : false
        }
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary50: "rgb(210 25 25 / 40%)",
            primary25: "rgb(210 25 25 / 40%)",
            primary: "rgb(210 25 25 / 80%)",
          },
        })}
      />
      <FieldError fieldName={field.name} />
    </div>
  );
};

export default Select;
